import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Input,
} from "reactstrap";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { useMst } from "store/RootStore";

const ChangePassword: React.FC = () => {
    const store = useMst();
    const history = useHistory();

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const clearFields = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
    };

    const handleChangePassword = async () => {
        try {
            if (!currentPassword || !newPassword || !confirmPassword) {
                throw new Error("All fields are required");
            }
            if (newPassword.length <= 6) {
                throw new Error("New password must be more than 6 characters");
            }
            if (newPassword !== confirmPassword) {
                throw new Error("Passwords do not match");
            }
            await store.userAccount.changePassword({
                currentPassword,
                newPassword,
            });

            toast.success("Password updated successfully!");
            clearFields();
            history.push("/admin/change-password");
        } catch (error) {
            if (error.response) {
                const backendMessage =
                    error.response.data.message ||
                    JSON.stringify(error.response.data) || 
                    "Password update failed";

                toast.error(backendMessage);
            } else {
                toast.error(error.message || "Password update failed");
            }
        }
    };

    return (
        <>
            <div className="header bg-default pb-6">
                <Container fluid>
                    <div className="header-body">
                        <Row className="align-items-center py-4">
                            <Col lg="6" xs="7">
                                <h6 className="h2 text-white d-inline-block mb-0">
                                    Change Password
                                </h6>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <Container className="mt--6" fluid>
                <Row className="justify-content-center">
                    <Col xl="6" lg="8" md="10">
                        <Card>
                            <CardBody>
                                <Form>
                                    <FormGroup>
                                        <label>Current Password</label>
                                        <Input
                                            type="password"
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <label>New Password</label>
                                        <Input
                                            type="password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <label>Confirm Password</label>
                                        <Input
                                            type="password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                    </FormGroup>
                                    <div className="text-center">
                                        <Button color="primary" onClick={handleChangePassword}>
                                            Update Password
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ChangePassword;